import {
  getMachinesByActivity, unBindMachine, bindMachine, saveMachineActivity, getMachineActivity, getMachineType,
  getMachineBrand,
  insertMachineType, updateMachineType, machineSave, machineGet, machineInfo, DelType, MachineDispense, SaveDispense,
  MachineError, MachineErrorList, MachineErrorDel, GetMachinesByScreenSaver, MachineErrorStatus, GetMachineConnect, SetMachineDate, GetMachineRenew, GetMachineReport,
  GetMachineTrack, SaveMachineTrack, SaveMachineLog, GetMachineLogList, MachineListConcise, GetMachineRepair,
  GetMachineDispense, GetAgentDispenseAccount, SaveMachineDispense, SaveMachineFuncs, GetMiniMachineStatus
} from '@/api/machine'
export default {
  state: {
    machine: [],
    machine_info: {}
  },
  getters: {
    machine: state => state.machine,
    machine_info: state => state.machine_info
  },
  actions: {
    getMachinesByActivity ({ commit }, payload) {
      return new Promise(resolve => {
        getMachinesByActivity(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    unBindMachine ({ commit }, payload) {
      return new Promise(resolve => {
        unBindMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    bindMachine ({ commit }, payload) {
      return new Promise(resolve => {
        bindMachine(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    saveMachineActivity ({ commit }, payload) {
      return new Promise(resolve => {
        saveMachineActivity(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    getMachineActivity ({ commit }, payload) {
      return new Promise(resolve => {
        getMachineActivity(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    initMachineInfo ({ commit }, payload) {
      commit('SET_MACHINE_INFO', {})
    },
    getType ({ commit }, payload) {
      return new Promise(resolve => {
        getMachineType(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    getBrand ({ commit }, payload) {
      return new Promise(resolve => {
        getMachineBrand(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    insertBrand ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        import('@/api/machine').then(({ insertMachineBrand }) => {
          insertMachineBrand(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        })
      })
    },
    delBrand ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        import('@/api/machine').then(({ delMachineBrand }) => {
          delMachineBrand(payload).then(res => {
            resolve(res.data)
          }).catch(err => {
            reject(err)
          })
        })
      })
    },
    insertType ({ commit }, payload) {
      return new Promise(resolve => {
        insertMachineType(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    updateType ({ commit }, payload) {
      return new Promise(resolve => {
        updateMachineType({
          id: payload.id,
          name: payload.name,
          brand: payload.brand,
          brand_id: payload.brand_id,
          type: payload.type,
          is_del: payload.is_del
        }).then(res => {
          resolve(res.data)
        })
      })
    },
    saveMachine ({ commit }, payload) {
      return new Promise(resolve => {
        machineSave(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    getMachine ({ commit }, payload) {
      return new Promise(resolve => {
        machineGet(payload).then(res => {
          commit('SET_MACHINE', res.data.data)
          resolve(res.data)
        })
      })
    },
    machineInfo ({ commit }, payload) {
      return new Promise(resolve => {
        machineInfo(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelType ({ commit }, payload) {
      return new Promise(resolve => {
        DelType(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineDispense ({ commit }, payload) {
      return new Promise(resolve => {
        MachineDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveDispense ({ commit }, payload) {
      return new Promise(resolve => {
        SaveDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineError ({ commit }, payload) {
      return new Promise(resolve => {
        MachineError(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineErrorDel ({ commit }, payload) {
      return new Promise(resolve => {
        MachineErrorDel(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineErrorList ({ commit }, payload) {
      return new Promise(resolve => {
        MachineErrorList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachinesByScreenSaver ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachinesByScreenSaver(payload).then(res => {
          res.data.map(item => {
            item.error = item.error ? item.error.replace(/off_line/g, '') : ''
          })
          commit('SET_MACHINE', res.data)
          resolve(res.data)
        })
      })
    },
    MachineErrorStatus ({ commit }, payload) {
      return new Promise(resolve => {
        MachineErrorStatus(payload).then(res => {
          commit('SET_MACHINE', res.data)
          resolve(res.data)
        })
      })
    },
    GetMachineConnect ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineConnect(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SetMachineDate ({ commit }, payload) {
      return new Promise(resolve => {
        SetMachineDate(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineRenew ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineRenew(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineReport ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineReport(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineTrack ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineTrack(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMachineTrack ({ commit }, payload) {
      return new Promise(resolve => {
        SaveMachineTrack(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMachineLog ({ commit }, payload) {
      return new Promise(resolve => {
        SaveMachineLog(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineLogList ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineLogList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    MachineListConcise ({ commit }, payload) {
      return new Promise(resolve => {
        MachineListConcise(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineRepair ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineRepair(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMachineDispense ({ commit }, payload) {
      return new Promise(resolve => {
        GetMachineDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetAgentDispenseAccount ({ commit }, payload) {
      return new Promise(resolve => {
        GetAgentDispenseAccount(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMachineDispense ({ commit }, payload) {
      return new Promise(resolve => {
        SaveMachineDispense(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveMachineFuncs ({ commit }, payload) {
      return new Promise(resolve => {
        SaveMachineFuncs(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetMiniMachineStatus ({ commit }, payload) {
      return new Promise(resolve => {
        GetMiniMachineStatus(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  mutations: {
    SET_MACHINE (state, payload) {
      state.machine = payload
    },
    SET_MACHINE_INFO (state, payload) {
      state.machine_info = payload
    }
  }
}
